module.exports = __webpack_public_path__ + "img/maneken_front.cdaba2b4.png";